<template>
  <div v-if="this.checkMobile()" class="grey-background-container">
    <!-- Mobile Screen -->
    <MobileNavigationBack
      :moduleRoute="moduleRoute"
      :appbarTitle="appbarTitle"
    ></MobileNavigationBack>
    <div class="p-2">
      <div class="max-w-7xl mx-auto sm:px-6 lg:px-8 p-5">
        <!-- <jet-button @click="back"  class="bg-blue-500 rounded text-white hover:bg-blue-500  hover:no-underline px-2 cursor-pointer  text-sm" >Back</jet-button> -->

        &nbsp;
      </div>
      <div class="max-w-7xl mx-auto">
        <div class="w-full">
          <div class="pb-8 mb-2">
            <!-- <div class="text-lg font-bold ">Create {{moduleName}}</div> -->
            <form @submit.prevent="submit">
              <BsEdit
                :slug="slug"
                :createDef="createDef"
                :routeDef="moduleRoute"
                :modelData="modelData"
                viewType="createview"
                ref="formRenderer"
              >
              </BsEdit>
              <div class="panel-footer mt-2 text-right">
                <jet-button
                  v-show="!checkAction()"
                  type="submit"
                  class="w-full text-center justify-center bg-green-500 text-sm rounded pl-2 pr-2 pt-1 hover:bg-green-500 text-white hover:no-underline"
                >
                  Create
                </jet-button>

                <!-- <jet-button
                    v-show="checkAction()"
                    @click="editItem"
                    class="
                      bg-blue-500
                      rounded
                      text-sm
                      pl-2
                      pr-2
                      pt-1
                      pb-1
                      text-white
                      hover:no-underline
                    "
                  >
                    Update
                  </jet-button> -->
              </div>
            </form>
          </div>

          <DxToast
            v-model:visible="isVisible"
            v-model:message="message"
            v-model:type="type"
          />
        </div>
      </div>
    </div>
  </div>

  <div v-else>
    <app-layout :title="title">
      <template v-slot:sidenav> </template>

      <template v-slot:horizonav>
        <nav-bar :scId="currentProduct" scType="product"> </nav-bar>
      </template>

      <!-- Breadcrumb -->
      <div class="mt-3 mb-2">
        <jet-back-link
          @click="back"
          class="max-w-7xl mx-auto mx-auto sm:px-6 lg:px-8"
        >
          <i class="fa fa-long-arrow-left" aria-hidden="true"></i>
          &nbsp; Go back
        </jet-back-link>
      </div>
      <!-- Breadcrumbs end -->

      <PageTitle :headerTitle="title"> </PageTitle>

      <div class="max-w-7xl mx-auto sm:px-6 lg:px-8">
        <p class="text-xs">{{ title }} with all mandatory fields</p>
      </div>

      <form @submit.prevent="submit">
        <div class="max-w-7xl mx-auto sm:px-6 lg:px-8 mt-2">
          <div class="w-full">
            <div class="">
              <div class="flex justify-start ...">
                <jet-button
                  v-show="!checkAction()"
                  type="submit"
                  class="bg-green-500 rounded text-white hover:bg-green-700 hover:no-underline px-2 cursor-pointer text-sm"
                  >Save</jet-button
                >
                <jet-button
                  @click="CreateAnother"
                  class="bg-blue-500 rounded text-white hover:bg-blue-700 hover:no-underline px-2 cursor-pointer text-sm"
                  >Save & Create Another</jet-button
                >
                <jet-button
                  @click.prevent="back"
                  @click="back"
                  class="bg-gray-500 rounded text-white hover:text-white hover:bg-gray-700 hover:no-underline px-2 cursor-pointer text-sm"
                  >Cancel</jet-button
                >
              </div>
              <!-- <div class="text-lg font-bold ">Create {{moduleName}}</div> -->

              <BsEdit
                :slug="slug"
                :createDef="createDef"
                :routeDef="moduleRoute"
                :modelData="modelData"
                :defaultDate="defaultDate"
                viewType="createview"
                ref="formRenderer"
              >
              </BsEdit>
              <div class="panel-footer mt-2"></div>
            </div>

            <div class="flex justify-start ...">
              <jet-button
                v-show="!checkAction()"
                type="submit"
                class="bg-green-500 rounded text-white hover:bg-green-700 hover:no-underline px-2 cursor-pointer text-sm"
                >Save</jet-button
              >
              <jet-button
                @click="CreateAnother"
                class="bg-blue-500 rounded text-white hover:bg-blue-700 hover:no-underline px-2 cursor-pointer text-sm"
                >Save & Create Another</jet-button
              >
              <jet-button
                @click.prevent="back"
                @click="back"
                class="bg-gray-500 rounded text-white hover:text-white hover:bg-gray-700 hover:no-underline px-2 cursor-pointer text-sm"
                >Cancel</jet-button
              >
            </div>

            <DxToast
              v-model:visible="isVisible"
              v-model:message="message"
              v-model:type="type"
            />
          </div>
        </div>
      </form>
    </app-layout>
  </div>
</template>

<script>
import AppLayout from "@/Layouts/AppLayout.vue";
import BsEdit from "@/Base/BsEdit.vue";
import PageTitle from "@/Layouts/PageTitle.vue";
import JetNavLink from "@/Jetstream/NavLink.vue";
import JetBackLink from "@/Jetstream/BackLink.vue";
import JetButton from "@/Jetstream/Button.vue";
import { DxToast } from "devextreme-vue/toast";
import MobileNavigation from "@/Layouts/MobileNavigation.vue";
import MobileNavigationBack from "@/Layouts/MobileNavigationBack.vue";
import NavBar from "../../Layouts/NavBar.vue";

const modelData = {};

export default {
  props: {
    createDef: Array,
    defaultDate: Boolean,
    moduleRoute: String,
    errors: Object,
    moduleName: String,
    slug: String,
    currentProduct: String,
    moduleLabel: String,
    err: {
      type: Object,
      default: () => ({}),
    },
    modelData: {
      type: Object,
      default: () => ({}),
    },
  },
  components: {
    AppLayout,
    BsEdit,
    PageTitle,
    JetNavLink,
    JetButton,
    DxToast,
    MobileNavigation,
    MobileNavigationBack,
    NavBar,
    JetBackLink,
  },
  data: function () {
    return {
      title: this.moduleLabel + " Create",
      appbarTitle: this.moduleLabel + " Create",
      form: this.$inertia.form(),
      isVisible: false,
      message: "",
      type: "success",
    };
  },
  methods: {
    showToast(message, type) {
      this.isVisible = true;
      this.message = message;
      this.type = type;
    },
    checkAction() {
      return this.modelData.hasOwnProperty("id") && this.modelData.id != "";
    },

   submit() {
  const rawData = this.$refs.formRenderer.formData;
  
  // Check if we have files to upload
  const hasFiles = Object.values(rawData).some(
    value => value && typeof value === "object" && value.file instanceof File
  );
  console.log("hasFiles", hasFiles);
  if (hasFiles) {
    // Use FormData approach for file uploads
    const formData = new FormData();
    
    // Add all form fields to the FormData
    for (const key in rawData) {
      const value = rawData[key];
      
      // Handle file uploads
      if (value && typeof value === "object" && value.file instanceof File) {
        formData.append(key, value.file);
      } 
      // Handle line items (convert objects to JSON strings)
      else if (key.includes('LineItem') && typeof value === 'object') {
        formData.append(key, JSON.stringify(value));
      } 
      // Handle all other fields
      else {
        formData.append(key, value);
      }
    }
    
    // Add route_slug if needed
    if (this.slug) {
      formData.append('route_slug', this.slug);
    }
    
    // Use Inertia with FormData
    this.$inertia.post(
      route(this.moduleRoute + ".store", this.slug),
      formData,
      {
        preserveScroll: true,
        forceFormData: true,
        onSuccess: () => {
          this.showToast("Successfully submitted", "success");
        },
        onError: (errors) => {
          console.error("Submission errors:", errors);
        },
      }
    );
  } else {
    // If no files, use the regular JSON approach
    const formData = { ...rawData };
    
    // Add route_slug if needed
    if (this.slug) {
      formData.route_slug = this.slug;
    }
    
    // Use Inertia with JSON data
    this.$inertia.post(
      route(this.moduleRoute + ".store", this.slug),
      formData,
      {
        preserveScroll: true,
        onSuccess: () => {
          this.showToast("Successfully submitted", "success");
        },
        onError: (errors) => {
          console.error("Submission errors:", errors);
        },
      }
    );
  }
},

    back() {
      this.$inertia.get("/" + this.slug + "/" + this.moduleRoute);
    },

    update() {
      this.form.post(
        route(this.moduleRoute + ".update", this.$refs.formRenderer.formData),
        {
          onSuccess: this.showToast("Successfully ", "success"),
        }
      );
    },
    checkMobile() {
      if (
        /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
          navigator.userAgent
        )
      ) {
        console.log("CheckMobile Called: Mobile");
        return true;
      } else {
        console.log("CheckMobile Called: Desktop");
        return false;
      }
    },
  },
  mounted() {
    this.checkMobile();
      console.log("error page ",this.$page.errors);
      console.log("CREATE MODEL DATA",this.modelData);
    const params = new URLSearchParams(window.location.search);
    this.baseRecordId = params.get("baseRecordId");
    console.log("CREATE SUBMODULE", this.subModule);
    console.log("CREATE BASEID", this.baseRecordId);
  },
};
</script>

<style>
.grey-background-container {
  background-color: #ffffff;
  height: 100vh;
}
.dx-field-item-label-text {
  color: #838282;
}
</style>